import { useStore } from "../store";

export const checkDevice = () => useStore.getState().checkDevice;
